// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"23d51abe","769":"50d61046"}[chunkId] + ".chunk.js";
};